import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_SCALE_INDEX } from "components/StageTimeline/geometry";

export const INITIAL_STATE = {
  stages: [],
  rows: [],
  isLoading: false,
  isInitialized: false,
  hasError: false,
  scaleIndex: DEFAULT_SCALE_INDEX,
};

export const createTimeline = ({ name, selectState, initialScaleIndex = DEFAULT_SCALE_INDEX }) => {
  const slice = createSlice({
    name,
    initialState: { ...INITIAL_STATE, scaleIndex: initialScaleIndex },
    reducers: {
      reset() {
        return INITIAL_STATE;
      },
      setTimelineLoading(state, { payload }) {
        state.isLoading = payload;
        if (payload) {
          state.hasError = false;
        }
      },
      setTimelineData(state, { payload }) {
        state.stages = payload?.stages ?? [];
        state.rows = payload?.rows ?? [];
        state.isLoading = false;
        state.isInitialized = true;
        state.hasError = false;
      },
      setTimelineError(state) {
        state.stages = [];
        state.rows = [];
        state.isLoading = false;
        state.isInitialized = true;
        state.hasError = true;
      },
      setScaleIndex(state, { payload }) {
        state.scaleIndex = payload;
      },
    },
  });

  return {
    slice,
    ...slice.actions,
    selectTimelineStages: (state) => selectState(state).stages,
    selectTimelineRows: (state) => selectState(state).rows,
    selectTimelineIsLoading: (state) => selectState(state).isLoading,
    selectTimelineIsInitialized: (state) => selectState(state).isInitialized,
    selectTimelineHasError: (state) => selectState(state).hasError,
    selectTimelineScaleIndex: (state) => selectState(state).scaleIndex,
  };
};
